<template>
  <sdCards :title="$t('pages.apps.modules.settings.new-title')">
    <a-result status="404" title="Yakında" sub-title="Bu sayfa geliştirilmektedir"> </a-result>
    <!-- <a-form layout="vertical" :model="formData" @submit="handleSubmit">
      <a-form-item :label="$t('pages.apps.modules.settings.setting-code') + ':'">
        <a-select ref="select" v-model:value="formData.selected_key" style="width: 200px">
          <a-select-option v-for="(setting, index) in setting_keys" :key="setting" :value="index"
            >{{ setting }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :label="$t('pages.apps.modules.settings.code') + ':'">
        <a-textarea
          :placeholder="$t('pages.apps.modules.settings.code')"
          :auto-size="{ minRows: 5, maxRows: 10 }"
          v-model:value="formData.code"
        />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" :loading="iconLoading" html-type="submit"> {{ $t('common.save') }} </a-button>
      </a-form-item>
    </a-form> -->
  </sdCards>
</template>

<script>
export default {
  name: 'Setting',
  data() {
    return {
      iconLoading: false,
      app_id: this.$route.params.id,
      type: 'setting',
      setting_keys: [],
      formData: {
        selected_key: null,
        code: null,
      },
    };
  },
  methods: {
    handleSubmit() {
      this.iconLoading = true;
      this.$appAxios
        .post(this.$endpoints.app_module_set, { id: this.app_id, formData: this.formData, type: this.type })
        .then((resp) => {
          if (resp.data.status) {
            this.$message.success(this.$t('common.success-message'));
            this.$store.dispatch('application/get', this.app_id);
            this.$router.push({ name: 'detail-module-setting' });
          } else {
            this.$message.error(resp.data.message);
          }
          this.iconLoading = false;
        });
    },
    getSettings() {
      this.$appAxios.post(this.$endpoints.app_module_setting_get).then((resp) => {
        if (resp.data.status) {
          this.setting_keys = resp.data.data;
          this.formData.selected_key = 0;
        } else {
          this.$message.error(resp.data.message);
        }
        this.iconLoading = false;
      });
    },
  },
  mounted() {
    this.getSettings();
  },
};
</script>